import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as adminActions from '../actions/adminActions';
import Dropzone from 'react-dropzone';
import { Button } from 'semantic-ui-react';
class AdminImportUsersPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			file: null
		};
		this.onDrop = this.onDrop.bind(this);
		this.onImport = this.onImport.bind(this);
		this.refresh = this.refresh.bind(this);
	}

	componentWillUnmount() {
		const { intervalId } = this.state;
		clearInterval(intervalId);
	}

	onDrop(files) {
		this.setState({ file: files[0] });
	}

	onImport() {
		const { actions } = this.props;
		actions.adminImportUsers(this.state.file);
		const intervalId = setInterval(this.refresh, 3000);
		this.setState({ intervalId });
	}

	async refresh() {
		const { actions } = this.props;
		const result = await actions.adminGetImportStatus();
		this.setState({ response: result.response });
	}

	render() {
		const { file, response } = this.state;
		return (
			<div style={{ width: '400px', marginLeft: 'auto', marginRight: 'auto' }}>
				{!response ? (
					<Dropzone
						onDrop={this.onDrop}
						style={{
							width: '100%',
							height: '200px',
							borderWidth: '2px',
							borderColor: 'rgb(102, 102, 102)',
							borderStyle: 'dashed',
							borderRadius: '5px',
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							marginBottom: '10px'
						}}>
						<p style={{ textAlign: 'center', verticalAlign: 'center' }}>{file ? 'Import' : 'Drop User File Here'}</p>
						{file ? <p style={{ textAlign: 'center', verticalAlign: 'center' }}>{file.name}</p> : null}
					</Dropzone>
				) : (
					<div
						style={{
							width: '100%',
							height: '200px',
							borderWidth: '2px',
							borderColor: 'rgb(102, 102, 102)',
							borderStyle: 'dashed',
							borderRadius: '5px',
							justifyContent: 'center',
							marginBottom: '10px',
							padding: '20px'
						}}>
						<h4>Scheduled: {response.scheduled || 0}</h4>
						<h4>Succeeded: {response.succeeded || 0}</h4>
						<h4>Processing: {response.processing || 0}</h4>
						<h4>Enqueued: {response.enqueued || 0}</h4>
					</div>
				)}
				{!response ? (
					<Button fluid primary disabled={!file} onClick={this.onImport}>
						Import Users
					</Button>
				) : null}
			</div>
		);
	}
}

AdminImportUsersPage.propTypes = {};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = dispatch => ({
	actions: {
		...bindActionCreators(adminActions, dispatch)
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminImportUsersPage);
